import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index';

function ordinalNumber(dirtyNumber, dirtyOptions) {
  const number = Number(dirtyNumber);

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
}

const eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Ngaphambi KoKrestu', 'Anno Domini'],
};

const quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Kota-1', 'Kota-2', 'Kota-3', 'Kota-4'],
  wide: [
    'ikota yokuqala',
    'ikota yesibini',
    'ikota yesithathu',
    'ikota yesine',
  ],
};

const monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: [
    'Jan',
    'Feb',
    'Mat',
    'Apr',
    'Meyi',
    'Jun',
    'Jul',
    'Aga',
    'Sep',
    'Okt',
    'Nov',
    'Dis',
  ],
  wide: [
    'Janyuwari',
    'Februwari',
    'Matshi',
    'Apreli',
    'Meyi',
    'Juni',
    'Julayi',
    'Agasti',
    'Septemba',
    'Oktobha',
    'Novemba',
    'Disemba',
  ],
};

const dayValues = {
  narrow: ['C', 'M', 'B', 'T', 'S', 'H', 'M'],
  short: ['Caw', 'Mvu', 'Bin', 'Tha', 'Sin', 'Hla', 'Mgq'],
  abbreviated: ['Caw', 'Mvu', 'Bin', 'Tha', 'Sin', 'Hla', 'Mgq'],
  wide: [
    'Cawa',
    'Mvulo',
    'Lwesibini',
    'Lwesithathu',
    'Lwesine',
    'Lwesihlanu',
    'Mgqibelo',
  ],
};

const dayPeriodValues = {
  narrow: {
    am: 'k',
    pm: 'e',
    midnight: 'ezinzulwini zobusuku',
    noon: 'emini',
    morning: 'kusasa',
    afternoon: 'emva kwemini',
    evening: 'ngorhatya',
    night: 'ubusuku',
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ezinzulwini zobusuku',
    noon: 'emini',
    morning: 'kusasa',
    afternoon: 'emva kwemini',
    evening: 'ngorhatya',
    night: 'ubusuku',
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'ezinzulwini zobusuku',
    noon: 'emini',
    morning: 'kusasa',
    afternoon: 'emva kwemini',
    evening: 'ngorhatya',
    night: 'ubusuku',
  },
};

const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    },
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
  }),
};

export default localize;
